//  cSpell: ignore bow eow bom eom bolm eolm boq eoq boy eoy bolq eolq boly eoly

import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";

import { IShellService } from "@tylertech/incode-module";
import { getLoggerFor, LogAccess, LogLevel } from "@tylertech/logging";

interface Window
{
    /**
     * This is needed for the core web search views THEY WILL NOT WORK IF IT IS REMOVED see ShellSuggestBox.DoWebSearch
     * @param text
     */
    // FIXME(DO-4549) - this should managed by library/incode
    executeOmniBarSearch(text: string): void;
}

declare const window: Window & globalThis.Window;

export interface ShortcutInfo
{
    Group: ShortcutGroupKey;
    Keys: string;
    Description: string;
}

export const enum OmniColorClass
{
    Indigo = "indigo",
    Teal = "teal",
    Blue = "blue",
    LightGreen = "light-green",
    Orange = "orange",
    Red = "red",
    BlueGrey = "blue-grey",
    Green = "green",
    Burgundy = "burgundy",
    Purple = "purple",
    Yellow = "yellow",
}

export const enum ShortcutGroupKey
{
    Global = "Global",
    ActionMenu = "Menu Action",
    Action = "Action",
    Dialog = "Dialog",
    View = "This Screen",
    Stepper = "Stepper",
    DateInput = "Date Input",
}

@Injectable()
export class OmniBarService implements OnDestroy
{
    private readonly log = getLoggerFor("OmniBarService");
    private readonly titleSubject = new BehaviorSubject<string>(undefined);
    private readonly showOmnibarSubject = new BehaviorSubject<boolean>(true);
    private readonly busySubject = new Subject<boolean>();
    private readonly searchChangeSubject = new Subject<string>();
    private readonly searchSubject = new Subject<string>();

    readonly titleChange: Observable<string>;
    readonly showOmnibar: Observable<boolean>;
    private readonly busyObservable: Observable<boolean>;
    private readonly searchChangeObservable: Observable<string>;
    private readonly searchObservable: Observable<string>;

    private _colorClass: OmniColorClass;

    constructor(
        private readonly $shellService: IShellService
    )
    {
        this.titleChange = this.titleSubject.asObservable();
        this.showOmnibar = this.showOmnibarSubject.asObservable();
        this.showOmnibarSubject.next(!$shellService.isEmbedded());

        this.busyObservable = this.busySubject.asObservable();
        this.searchChangeObservable = this.searchChangeSubject.asObservable();
        this.searchObservable = this.searchSubject.asObservable();

        this.registerCefSharpBridge();
    }

    ngOnDestroy(): void
    {
        this.titleSubject.complete();
        this.showOmnibarSubject.complete();
        this.busySubject.complete();
        this.searchChangeSubject.complete();
        this.searchSubject.complete();
    }

    /** @deprecated - Does anything use this observable? */
    get busy(): Observable<boolean> { return this.busyObservable; }
    get searchChange(): Observable<string> { return this.searchChangeObservable; }
    get search(): Observable<string> { return this.searchObservable; }


    // FIXME(DO-4549) - this should managed by library/incode
    private registerCefSharpBridge(): void
    {
        if (!this.$shellService.isEmbedded() || window.executeOmniBarSearch)
        {
            return;
        }

        const self = this;
        window.executeOmniBarSearch = function executeOmniBarSearch(text: string): void
        {
            self.searchSubject.next(decodeURIComponent(text));
        };
    }

    @LogAccess({ level: LogLevel.DEBUG, logSet: true })
    get title(): string { return this.titleSubject.value; }

    set title(v: string)
    {
        this.titleSubject.next(v);
    }

    get colorClass(): OmniColorClass { return this._colorClass ?? OmniColorClass.Indigo; }
    set colorClass(v: OmniColorClass)
    {
        this._colorClass = v ?? OmniColorClass.Indigo;
    }

    /** @deprecated - clearly, this belongs on the commandService in library/commands..... */
    setCommandMenuBusy(value: boolean): void
    {
        this.busySubject.next(value);
    }

    setSearchChanged(value: string): void
    {
        this.searchChangeSubject.next(value);
    }

    setOmnibarVisible(show: boolean): void
    {
        this.showOmnibarSubject.next(show);
    }
}
